/* SPLENDIDO Bar T-Lab Switcher — versione GLOBALE
   Identico a sp-frame.js ma senza gate template-index: clona il T-Lab desktop switcher
   nella announcement bar su QUALSIASI pagina del sito.
   Idempotente: se il clone esiste gia' (es. inserito da sp-frame.js sulla home), esce subito.
   Tema MOD 2026-05-24 */
(function() {
  var done = false;
  function setup() {
    if (done) return;

    var orig = document.querySelector('.shopify-section--header .tl-switcher-container.desktop')
            || document.querySelector('.shopify-section-group-header-group .tl-switcher-container.desktop');
    var bar = document.querySelector('.shopify-section--announcement-bar .announcement-bar')
           || document.querySelector('.shopify-section--announcement-bar .container')
           || document.querySelector('.shopify-section--announcement-bar');

    if (!orig || !bar) return;
    if (bar.querySelector('.sp-bar-tlswitcher-slot')) { done = true; return; }

    var origSelections = orig.querySelector('.tl-wrapper > .tl-selections');
    var overlay = orig.querySelector('.tl-overlay');
    if (!origSelections || !overlay) return;

    var slot = document.createElement('div');
    slot.className = 'sp-bar-tlswitcher-slot';
    var cloneTrigger = origSelections.cloneNode(true);
    slot.appendChild(cloneTrigger);
    bar.appendChild(slot);

    slot.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      overlay.classList.toggle('active');
    });

    var closeBtn = overlay.querySelector('.tl-close-btn');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        overlay.classList.remove('active');
      });
    }
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.classList.remove('active');
    });

    done = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  setTimeout(setup, 500);
  setTimeout(setup, 1500);
  setTimeout(setup, 3000);
})();
